import { render, staticRenderFns } from "./UploadFileWithPreview.vue?vue&type=template&id=4d7b006b"
import script from "./UploadFileWithPreview.vue?vue&type=script&lang=js"
export * from "./UploadFileWithPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports